import React, { useState } from "react"
import { Image, Stage, Layer, Circle, Group, Rect } from 'react-konva';

import { useAnimationFrame, useWindowSize } from "../../Helper"

import QDFTextImage from "../../Assets/queerdenker_festival_text.png"
import LogosImage from "../../Assets/logos_igtv_1080x1920.png"

const AnimatedCircle = ({
    initialRotation = 0,
    color = "red",
    onClick,
    blendMode,
    canvasWidth = window.innerWidth,
    canvasHeight = window.innerHeight,

    size = 1,

    radiusMultiplier
}) => {
    const [count, setCount] = useState(initialRotation);

    useAnimationFrame(i => {
        setCount(prevCount => prevCount + 0.035);
    })

    const initPos = 15 * size;
    const initRadius = 125 * size;

    let modulationCos = Math.cos(count) * -Math.PI;
    let modulationSin = Math.sin(count) * Math.PI;
    let modulation = modulationSin * modulationCos;

    let offsetX = canvasWidth / 2;
    let offsetY = canvasHeight / 2;

    let x = (initPos * Math.sin(count) + offsetX) + modulation;
    let y = (initPos * Math.cos(count) + offsetY) + modulation;

    let radius = (initRadius * radiusMultiplier) + 10 * Math.sin(count);

    return (
        <Circle
            globalCompositeOperation={blendMode}
            x={x}
            y={y}
            radius={radius}
            fill={color}
            onClick={e => onClick(e)}
            onTap={e => onClick(e)}
        />
    )
}

const LogoAnimation = ({ height = 400, width = 400, size = 1 }) => {
    const blendModes = ["darken", "lighten"/* , "hue", "luminance" */]
    const [blendMode, setBlendMode] = useState(blendModes[0]);

    const [counter, setCounter] = useState(0);
    const [radius, setRadius] = useState(1);

    const [textImage, setTextImage] = React.useState(null);
    const [logoImage, setLogoImage] = React.useState(null);

    const props = {
        onClick: (e) => {
            if(!counter || counter === 1) {
                const newBlendModeIndex = blendModes.indexOf(blendMode) + 1;
                let newBlendMode = blendModes[newBlendModeIndex] || blendModes[0];
                setBlendMode(newBlendMode);
                setRadius(1);
            } else {
                counter === 2 ? setRadius(1.5) : setRadius(0.75)
            }

            if(counter === 3) {
                setCounter(0);
            } else {
                setCounter(counter + 1);
            }
        },
        blendMode,
        canvasWidth: width,
        canvasHeight: height,

        radiusMultiplier: radius,

        size
    }

    const center = {
        x: width / 2,
        y: height / 2
    }

    const textWidth = 143 * size;
    const textHeight = 82 * size;
    const textProps = {
        height: textHeight,
        width: textWidth,
        x: Math.floor(center.x - (textWidth / 2)),
        y: Math.floor(center.y - (textHeight / 3)),
    }

    React.useLayoutEffect(() => {
        let image = null;
        if(!textImage) {
            image = new window.Image();
            image.src = QDFTextImage;
            setTextImage(image);
        }

        if(!logoImage) {
            image = new window.Image();
            image.src = LogosImage;
            setLogoImage(image);
        }
    })

    return (
        <Stage width={width} height={height}>
            <Layer>
                <Rect height={height} width={width} fill={"white"}></Rect>

                <Image image={logoImage} />

                <Group>
                    <AnimatedCircle {...props} color="cyan" />
                    <AnimatedCircle {...props} color="magenta" initialRotation={2 / 3 * 2 * Math.PI} />
                    <AnimatedCircle {...props} color="yellow" initialRotation={1 / 3 * 2 * Math.PI} />
                </Group>

                <Image {...textProps} image={textImage} />
            </Layer>
        </Stage>
    );
}
export default LogoAnimation